module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.8932/img/video-thumb-overlay.png"